const STORAGE_KEY = 'wt_theme_mode';
const LEGACY_STORAGE_KEY = 'GLOBAL_THEME';

export type ThemeMode = 'light' | 'dark';

export const loadThemeMode = (): ThemeMode =>
  (localStorage.getItem(STORAGE_KEY) as ThemeMode) || 'light';

export const saveThemeMode = (theme: ThemeMode): void => {
  localStorage.setItem(STORAGE_KEY, theme);
  localStorage.removeItem(LEGACY_STORAGE_KEY);
};
